const BASE_URL = process.env.REACT_APP_BASE_URL;

const handleResponse = async (response) => {
  if (response.status === 401 || response.status === 403) {
    localStorage.removeItem('some-key');
    window.location.href = '/signin';
    throw new Error('Authentication failed');
  }
  return response.json();
};

export const sessionService = {
  async fetchSessions(unitId) {
    const response = await fetch(`${BASE_URL}/sessions/${unitId}`, {
      credentials: 'include'
    });
    return handleResponse(response);
  },

  async fetchSessionsByProject(unitId, project) {
    const response = await fetch(`${BASE_URL}/sessions/${unitId}?project=${project}`, {
      credentials: 'include'
    });
    return handleResponse(response);
  },

  async fetchCanSummary(unitId, project, session) {
    const response = await fetch(`${BASE_URL}/sessions/can-summary/${unitId}/${project}/${session}`, {
      credentials: 'include'
    });
    return handleResponse(response);
  },

  async fetchGpsData(unitId, project, session) {
    const response = await fetch(`${BASE_URL}/sessions/gps-data/${unitId}/${project}/${session}`, {
      credentials: 'include'
    });
    return handleResponse(response);
  },

  async fetchClgChunk(unitId, project, session, startTime, endTime, dbcFile = null) {
    const url = dbcFile 
      ? `${BASE_URL}/sessions/clg-data/${unitId}/${project}/${session}/chunk?startTime=${startTime}&endTime=${endTime}&dbcFile=${encodeURIComponent(dbcFile)}`
      : `${BASE_URL}/sessions/clg-data/${unitId}/${project}/${session}/chunk?startTime=${startTime}&endTime=${endTime}`;
    const response = await fetch(url, {
      credentials: 'include'
    });
    return handleResponse(response);
  },

  async fetchDbLogs(unitId, project, session) {
    const response = await fetch(`${BASE_URL}/sessions/db-logs/${unitId}/${project}/${session}`, {
      credentials: 'include'
    });
    return handleResponse(response);
  }
};